import React, { useState, useRef } from "react";
import ReactDOMServer from "react-dom/server";

import {
  Box,
  Grid,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider,
  Tooltip,
  IconButton
} from "@mui/material";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import { Close, Print } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";

// A separate component for the report's content to facilitate printing
const PickListReportContent = ({ reportData, handleBackToSalesOrderDetails, picklistData }) => {
  

  const reportRef = useRef();

  const totalQty = picklistData?.clsPickList?.PlanPickListItem?.reduce(
    (sum, item) => sum + (item._Qty || 0),
    0
  );

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });


  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center" padding={0}>
        {/* Left-aligned: Edit Employee */}
        <Grid item>
          <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
            Delivery Order Pick List Report
          </Typography>
        </Grid>

        {/* Right-aligned: Buttons */}
        <Grid item>
          <Grid container alignItems="center">
            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            {/* Save */}
            <Grid item ml={1} mr={1}>
              <Tooltip title="Add new orders">
                <IconButton
                  onClick={() => handlePrint()}
                  sx={{ display: 'flex', alignItems: 'center' }}
                // type="submit"
                >
                  <Print style={{ fontSize: "18px", color: "#009688" }} />
                  <Typography variant="body2" sx={{ ml: 1 }}> Print</Typography>
                </IconButton>
              </Tooltip>
            </Grid>

            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

            <IconButton onClick={handleBackToSalesOrderDetails}>
              <Close style={{ fontSize: "14px", color: "#2196F3" }} />
            </IconButton>

            <Divider orientation="vertical" flexItem />

          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Box>
        {/* Report wrapper */}
        <Paper
          ref={reportRef}
          elevation={0}
          sx={{
            p: 3,
            bgcolor: "#fff",
            width: "210mm",
            minHeight: "297mm",
            mx: "auto",
            color: "#000",
            mt: 2,
            mb: 2,
            fontSize: "10px",
          }}
        >
          {/* Company Header */}
          <Grid container alignItems="center" >
            {/* Logo */}
            <Grid item xs={3} sx={{ textAlign: "left" }}>
              <Box
                component="img"
                src="./Assets/images/papyrus3602.png"
                alt="FSC Logo"
                sx={{ width: 100, height: "auto" }}
              />
              <Typography variant="caption" display="block">
                www.fsc.org <br /> FSC® C210691 <br />
                The mark of responsible forestry
              </Typography>
            </Grid>

            {/* Company Info */}
            <Grid item xs={6} sx={{ textAlign: "center" }}>
              <Typography variant="h6" fontWeight="bold">
                {picklistData.clsPickList.ICompanyName}
              </Typography>
              <Typography variant="body2">
                {[
                  picklistData.clsPickList.ICompanyAddrLine1,
                  picklistData.clsPickList.ICompanyAddrLine2,
                  picklistData.clsPickList.ICompanyAddrLine3
                ].filter(Boolean).join(" ")}
              </Typography>

              <Typography variant="body2">Email ID: {picklistData.clsPickList.ICompanyAddrEmailId}</Typography>
              <Typography variant="body2">GSTIN: {picklistData.clsPickList.ICompanyGSTNo}</Typography>
            </Grid>

            {/* Report Title */}
            <Grid item xs={3} sx={{ textAlign: "right" }}>
              <Typography variant="h6" fontWeight="bold">
                Pick List
              </Typography>
            </Grid>
          </Grid>


          {/* Delivery Details */}
          <Table size="small" sx={{
            border: "1px solid #000",
            borderBottom: "none",   // 👈 removes bottom border
            mt: 1,
            color: "black"
          }}>
            <TableBody>
              <TableRow>
                <TableCell colSpan={3} sx={{ border: "1px solid #000", color: "black" }}>
                  <b>Delivery Order No:</b> {picklistData.clsPickList.IDeliveryOrderNo}
                </TableCell>
                <TableCell colSpan={3} sx={{ border: "1px solid #000", color: "black" }}>
                  <b>Date:</b>   {dayjs(picklistData.clsPickList.IDeliveryOrderDate).format("DD-MMM-YYYY")}
                </TableCell>

                <TableCell colSpan={3} sx={{ border: "1px solid #000", color: "black" }}>
                  <b>Truck Number:</b> {picklistData.clsPickList.TruckNumber}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>



          {/* Bill To / Ship To */}
          <Table size="small" sx={{ border: "1px solid #000", p: "4px", color: "black", borderTop: "none", borderBottom: "none", }}>
            <TableBody  >
              <TableRow>
                <TableCell colSpan={3} sx={{ border: "1px solid #000", borderTop: "none", verticalAlign: "top", color: "black", marginRight: "10px" }}>
                  <Typography variant="subtitle2"><b>Bill To</b></Typography>
                  Parent: {picklistData.clsPickList.PlanPickListGroupedItem[0]._IBillToParentName}<br />
                  Bill to: {picklistData.clsPickList.IBillToName}
                </TableCell>
                <TableCell colSpan={3} sx={{ border: "1px solid #000", borderTop: "none", verticalAlign: "top", color: "black" }}>
                  <Typography variant="subtitle2"><b>Ship To</b></Typography>
                  Ship to: {picklistData.clsPickList.IShipToName}
                </TableCell>
              </TableRow>


            </TableBody>
          </Table>

          {/* Items Table */}
          <Table size="small" sx={{ border: "1px solid #000", borderCollapse: "collapse", color: "black", borderTop: "none", }}>
            <TableHead sx={{ borderTop: "none", }}>
              <TableRow sx={{ bgcolor: "#eaeaea", fontWeight: "bold", color: "black", borderTop: "none", }}>
                <TableCell sx={{ border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">S.No</TableCell>
                <TableCell sx={{  width: "150px", border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">Quality</TableCell>
                <TableCell sx={{ border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">GSM</TableCell>
                <TableCell sx={{ width: "150px", border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">Size (Inch)</TableCell>
                <TableCell sx={{ border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">Location</TableCell>
                <TableCell sx={{ border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">Reams/Bundle</TableCell>
                <TableCell sx={{ border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">No. of Reels/Bundles</TableCell>
                <TableCell sx={{ border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">Weight (Kg)</TableCell>
                <TableCell sx={{ border: "1px solid #000", color: "black", fontWeight: "bold", borderTop: "none" }} align="center">Picked?</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {picklistData.clsPickList.PlanPickListGroupedItem.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{ border: "1px solid #000", color: "black", borderTop: "none" }}
                    align="center"
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }}>{item._Variety}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }} align="right">{item._GSM}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }} align="center">{item._Width} X {item._Length}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }} align="center">{item._Location}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }} align="right">{item._ReamsPerBundle}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }} align="right">{item._NoOfBundlesReels}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }} align="right">{item._Qty}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", color: "black", borderTop: "none" }} align="center">
                    <input type="checkbox" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Totals */}
          <Table size="small" sx={{ border: "1px solid #000", borderTop: "none", }}>
            <TableBody>
              <TableRow>
                <TableCell sx={{ textAlign: "right", fontWeight: "bold", color: "black" }}>
                  Total Qty (Kg):
                </TableCell>
                <TableCell sx={{ textAlign: "right", color: "black" }}>{totalQty}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          {/* Footer Signatures */}
          <Grid container sx={{ border: "1px solid #000", borderTop: "none" }}>
            <Grid mt={8} item xs={4} sx={{ textAlign: "center" }}>
              <Typography>Prepared By</Typography>
            </Grid>
            <Grid mt={8} item xs={4} sx={{ textAlign: "center" }}>
              <Typography>Checked By</Typography>
            </Grid>
            <Grid mt={2} item xs={4} sx={{ textAlign: "center" }}>
              <Typography>For {picklistData.clsPickList.ICompanyName}</Typography>
              <Typography sx={{ mt: 3 }}>Authorized Signatories</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </>
  );
};

// Main component with state and print button
const DeliverOrderPickListReport = ({ handleBackToSalesOrderDetails, picklistData }) => {
  const defaultReportData = {
    Header: {
      DeliveryOrderNo: "DO-201-2025",
      Date: "28-Jul-2025",
      TruckNumber: "DL01GC0447",
    },
    BillTo: {
      Parent: "AS PACKERS PROVIDERS (P) LTD",
      Name: "AS PACKERS PROVIDERS (P) LTD",
    },
    ShipTo: {
      Name: "AS PACKERS PROVIDERS (P) LTD",
    },
    Supplier: {
      Name: "NETIQUE INFOTECH PRIVATE LIMITED",
      Address: "8.5 km, Jansath Road,, Muzaffarnagar UTTAR PRADESH, INDIA 251001",
      GSTIN: "09AABCR1065J1ZC",
    },
    Items: [
      {
        S_No: 1,
        Quality: "AURA",
        GSM: "230",
        Size: "23.00 x 25.00",
        Location: "CLAXA",
        Reams_per_Bundle: 38,
        No_of_Reels_Bundles: 100,
        Weight_Kg: 7220.000,
      },
    ],
    Total: {
      TotalQtyKg: 7220.00,
    },
  };

  const [reportData] = useState(defaultReportData);


  return (

      <PickListReportContent reportData={reportData} handleBackToSalesOrderDetails={handleBackToSalesOrderDetails} picklistData={picklistData} />
  );
};

export default DeliverOrderPickListReport;